module.exports = "/assets/c817c9312a2bbae4d7348eac63d0a550.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TJ.png
// module id = 2978
// module chunks = 0